import { render, staticRenderFns } from "./ClientProfilePage.vue?vue&type=template&id=13c17763&scoped=true&"
import script from "./ClientProfilePage.vue?vue&type=script&lang=js&"
export * from "./ClientProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfilePage.vue?vue&type=style&index=0&id=13c17763&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c17763",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader,VTab,VTabs})
